import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function SEOArticleSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 lg:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-20">
          {/* Left Label */}
          <div className="lg:w-1/4 shrink-0">
            <span className="text-xs font-medium text-foreground-400 tracking-widest uppercase">
              {t('seo_section_label')}
            </span>
          </div>

          {/* Right Content */}
          <div className="lg:w-3/4">
            <p className="font-heading text-lg md:text-xl lg:text-2xl text-foreground-800 leading-relaxed font-light mb-8">
              {t('seo_section_text')}
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <Link
                to="/artykul-kakobuy-poradnik"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-background-50 text-sm font-medium rounded-lg hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-article-line"></i>
                {t('btn_read_article')}
              </Link>
              <div className="flex flex-wrap items-center gap-2">
                <Link to="/cssbuy-spreadsheet" className="text-xs text-foreground-500 hover:text-accent-500 transition-colors underline underline-offset-2">
                  CSSBuy Spreadsheet
                </Link>
                <span className="text-foreground-300 text-xs">·</span>
                <Link to="/superbuy-spreadsheet" className="text-xs text-foreground-500 hover:text-accent-500 transition-colors underline underline-offset-2">
                  Superbuy Spreadsheet
                </Link>
                <span className="text-foreground-300 text-xs">·</span>
                <Link to="/oopbuy-spreadsheet" className="text-xs text-foreground-500 hover:text-accent-500 transition-colors underline underline-offset-2">
                  Oopbuy Spreadsheet
                </Link>
              </div>
            </div>
            <div className="flex items-center gap-3 mt-4">
              <div className="flex -space-x-2">
                <div className="w-8 h-8 rounded-full bg-foreground-300 border-2 border-background-100"></div>
                <div className="w-8 h-8 rounded-full bg-foreground-400 border-2 border-background-100"></div>
                <div className="w-8 h-8 rounded-full bg-foreground-500 border-2 border-background-100"></div>
              </div>
              <span className="text-xs text-foreground-500 max-w-[160px]">
                {t('seo_section_author')}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}